import React, { useState, useEffect } from 'react';
import config from '../config';
import '../styles/Nav.css';

function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 8);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`nav ${isScrolled ? 'solid' : ''}`} id="nav">
      <div className="brand">
        <div className="brand-logo" aria-hidden="true">
          <span>nu</span>
        </div>
        <span className="brand-name">非凡工作</span>
        <span className="brand-domain">nuwork.cn</span>
      </div>
      <div className="nav-right">
        <a 
          className="pill pill-dark pill-sm" 
          href={config.market.home}
          target="_blank" 
          rel="noopener noreferrer"
        >
          应用市场
        </a>
      </div>
    </header>
  );
}

export default Nav;
